/**
 * Gera/persiste o `qr_session_id` (UUID v4) em `sessionStorage` — vive
 * apenas enquanto a aba está aberta. Correlaciona view → cta → outcome
 * do mesmo scan no qr_scan_events do backend.
 *
 * Por que sessionStorage e não localStorage: scan diferente = sessão
 * diferente. Se o motorista escaneia o adesivo de novo amanhã, queremos
 * um novo qr_session_id.
 */

const KEY = 'bow-qr-session-id';

export function getOrCreateQrSessionId(): string {
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) return existing;
  } catch {
    // sessionStorage indisponível (modo privado iOS Safari raro) — gera
    // um id volátil só pra esta página.
    return crypto.randomUUID();
  }
  const fresh = crypto.randomUUID();
  try {
    sessionStorage.setItem(KEY, fresh);
  } catch {
    /* ignore */
  }
  return fresh;
}
